'use strict';

var _ = require('underscore');
var Radio = require('backbone.radio');
var polyglot = require('../utilities/polyglot').default;
var Marionette = require('backbone.marionette');
var Tracker = require('../../analytics/events').default;
var CustomForm = require('./custom-forms/form-container').default;
var FormQuestions = require('../collections/form-questions').default;

export default Marionette.View.extend({
  className: 'coconut-modal',
  template: require('./templates/cancel-toast.hbs'),
  ui: {
    notes: '.notes',
    cancelMsg: '.cancel-message',
    close: '.close-button',
    confirm: '.confirm-cancel',
  },
  events: {
    'click @ui.close': 'dismiss',
    'click @ui.confirm': 'onConfirmClicked',
  },
  regions: {
    customForm: '.custom-cancel-form',
  },

  initialize: function (options) {
    this.parent = options.parent;
    this.model = options.model;
    this.time = options.time;
    this.zone = options.zone;
    this.buttonClass = 'green';
    this.showNotes = options.showNotes;
    this.isNotesRequired = options.isNotesRequired;
    this.className = 'coconut-modal';
    this.canCancel = options.canCancel;
    this.isPrivate = options.isPrivate;
  },

  serializeData: function() {
    return {
      cancelTitle: polyglot.t('confirmation.cancel_title'),
      isPrivate: this.model.isPrivate() || this.model.isInviteOnly(),
      cannotRebookMessage: polyglot.t('cancel.cannot_rebook'),
      message: polyglot.t('confirmation.cancel_message'),
      time: this.time,
      zone: this.zone,
      showNotes: this.showNotes,
      isNotesRequired: this.isNotesRequired,
      backMessage: polyglot.t('nav.back'),
      buttonMessage: polyglot.t('confirmation.cancel'),
      buttonClass: this.buttonClass,
      customFormEnabled: this.customFormEnabled,
    };
  },

  onRender: function() {
    if (this.customFormEnabled) {
      const questions = window.CANCEL_FORM ? window.CANCEL_FORM.questions : [];
      this.customForm = new CustomForm({
        collection: new FormQuestions(questions),
      });
      this.getRegion('customForm').show(this.customForm);
    }
  },

  /**
   * Display the modal.
   */
  show: function() {
    this.$el.removeClass('hide');
    this.$el.addClass('show');
  },

  /**
   * Dismiss the modal.
   */
  dismiss: function (evt) {
    evt.preventDefault();
    this.$el.removeClass('show');
    this.$el.addClass('hide');
  },

  /**
   * get the cancellation message for the cancel modal, that includes the
   * appointment start date/time.
   *
   * @returns {*}
   */
  getCancelMessage: function (time) {
    return polyglot.t('confirmation.cancel_message');
  },

  getNotes: function () {
    return this.ui.notes.val();
  },

  showErrors: function () {
    _.each(this.model.validationError, _.bind(this.showError, this));
    if (this.customForm) {
      _.each(this.customForm.getErrors(), _.bind(this.showCustomFormError, this));
    }
  },

  showError: function (error, field) {
    if (this.ui[field]) {
      this.ui[field].addClass('invalid');
      this.ui[field].after('<div class="form-error">' + error + '</div>');
    } else if (field === 'status') {
      this.ui.cancelMsg.after('<div class="form-error">' + error + '</div>');
    } else {
      var el = this.$('#' + field);
      if (el && el.length) {
        el.addClass('invalid');
        el.after('<div class="form-error">' + error + '</div>');
      }
    }
  },

  showCustomFormError: function (error) {
    this.customForm.showError(error);
  },

  hideErrors: function () {
    this.$('.invalid').removeClass('invalid');
    this.$('.form-error').remove();
  },

  onConfirmClicked: function () {
    Tracker.trackEvent('Appointment Cancelled', 'click');
    const notes = this.getNotes();
    let exists;
    this.hideErrors();
    this.model.isValidAppointment().done((response) => {
      exists = !!response;
    }).fail(() => {
      exists = false;
    }).always(() => {
      const valid = this.customForm
        ? this.customForm.validateFormQuestions()
        : this.model.isValid({ notes: notes, step: 'cancel', validate: true });

      if (exists && valid) {
        this.model.cancel(notes).done(() => {
          this.finishCancel();
        }).fail((response) => {
          this.ui.cancelMsg.after('<div class="form-error">' + response.responseJSON.errors[0].detail + '</div>');
        });
      } else if (exists && !valid) {
        this.showErrors();
      } else {
        this.ui.cancelMsg.after('<div class="form-error">' + polyglot.t('pages.cancel.already_cancelled') + '</div>');
      }
    });
  },

  finishCancel: function () {
    Radio.channel('complete-cancel').trigger('complete:cancel');
  },
});
